export default __webpack_public_path__ + "static/media/partner1.c5da20d1.png";